// This function allow to reference async chunks
__webpack_require__.u = function(chunkId) {
	// return url for filenames based on template
	return "static/js/" + chunkId + "." + {"782":"7d3b88ed","847":"7f835266"}[chunkId] + ".chunk.js";
};